import React, { useState, } from 'react';
import { Container, Row, Col, Card, FormGroup, Label, Input, Button, CardBody, CardHeader } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../Bi/stylePbi.css'
import { useReportSamplesP } from '../../../hooks/Pbi/useReportSamplesP';
import Select from 'react-select';

export const IndexReportSamplesPending = () => {
    const {
        // #region Filters
        mDateRange1, mDateRange2, mSelectBranch, branches,
        // #endregion 

        handleInputChange, handleSelectValues, loading,
        getReportPending, reportPendingExams,


        //clear
        handleCleanBranch, handleClean,

        // search Exams
        handleSearch,

        //excekl
        exportExcel,

        renderStatus, renderSend1Status, renderSend2Status, nimColors, getContrastColor,
        renderSend1CurvesStatus, renderSend2CurvesStatus, renderTomaCurves



    } = useReportSamplesP();
    console.log("🚀 ~ IndexReportSamplesPending ~ reportPendingExams:", reportPendingExams)
    const [expandedRows, setExpandedRows] = useState([]);


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };


    const rowExpansionTemplate = (rowData) => {
        if (rowData.items && (rowData.is_curve || rowData.is_profile)) {
            return (
                <div style={{
                    background: "linear-gradient(135deg, #cfd1d3ff 0%, #ebe7e7ff 100%)",
                    borderRadius: "12px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    padding: "15px",
                    marginTop: "10px"
                }}>
                    <h6 style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "#103c58ff",
                        marginBottom: "10px",
                        fontSize: "14px"
                    }}>
                        {rowData.is_curve ? "Detalle de Curvas" : "Detalle de Perfil"}
                    </h6>

                    <DataTable value={rowData.items} className="p-datatable-sm"
                        rows={10}
                        paginator

                        loading={loading}
                        rowsPerPageOptions={[10, 50, 100]}
                        responsiveLayout="scroll"

                        style={{ borderRadius: "8px", overflow: "hidden" }}
                    >
                        <Column
                            field="exam_name"
                            header={rowData.is_curve ? "Toma" : "Estudio"}
                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                            style={cellStyle}
                        />
                        <Column
                            field="barcode"
                            header="Etiqueta"
                            headerStyle={{ backgroundColor: "#82a6bc", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                            style={cellStyle}
                        />
                        <Column
                            field="is_toma"
                            header="Toma"
                            body={renderTomaCurves}
                            headerStyle={{ backgroundColor: "#82a6bc", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                            style={cellStyle}
                        />
                        <Column
                            field="name_branch_origin"
                            header="Sucursal Origen"
                            headerStyle={{ backgroundColor: "#7fbbecff", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                            style={cellStyle}
                        />
                        <Column
                            field="is_send1"
                            header="Envío"
                            body={renderSend1CurvesStatus}
                            headerStyle={{ backgroundColor: "#7fbbecff", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                            style={cellStyle}
                        />

                        <Column
                            field="init_time_procces2"
                            header="Fecha Envío"
                            headerStyle={{ backgroundColor: "#7fbbecff", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                            style={cellStyle}
                        />
                        <Column
                            field="name_branch_destination"
                            header="Sucursal Destino"
                            headerStyle={{ backgroundColor: "#0079c7", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                            style={cellStyle}
                        />
                        <Column
                            field="is_send2"
                            header="Recepción"
                            body={renderSend2CurvesStatus}
                            headerStyle={{ backgroundColor: "#0079c7", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                            style={cellStyle}
                        />
                        <Column
                            field="init_time_procces3"
                            header="Fecha Recepción"
                            headerStyle={{ backgroundColor: "#0079c7", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                            style={cellStyle}
                        />
                    </DataTable>
                </div>
            );
        }

        return null;
    };

    const customBody = (rowData) => {
        const bgColor = nimColors[rowData.nim] || "#ccc";
        const color = getContrastColor(bgColor);

        return (
            <span
                style={{
                    display: "inline-block",
                    padding: "4px 10px",
                    borderRadius: "999px",
                    backgroundColor: bgColor,
                    color: color,
                    fontWeight: "600",
                    fontSize: "12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                }}
            >
                {rowData.nim}
            </span>
        );
    };


    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/price/microType.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Reporte de muestras pendientes
                                    </h4>
                                    <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Análisis detallado de las muestras pendientes de procesar en el area operativa.
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                {
                    // * REPORT
                }
                <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                    <Col sm="12" className='pt-3'>
                        <Row>
                            <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    height: '100%',
                                    borderRadius: '12px'
                                }}>
                                    <CardHeader style={{
                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '12px 12px 0 0'
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                            <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                        </h6>
                                    </CardHeader>
                                    <CardBody style={{ padding: '20px' }}>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                            </Label>
                                            <Input
                                                type="date"
                                                value={mDateRange1}
                                                name="mDateRange1"
                                                onChange={handleInputChange}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                            </Label>
                                            <Input
                                                type="date"
                                                value={mDateRange2}
                                                name="mDateRange2"
                                                onChange={handleInputChange}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Sucursales
                                            </Label>

                                            <Select
                                                name="mSelectBranch"
                                                isClearable={true}
                                                placeholder="Selecciona una sucursal"
                                                options={branches}
                                                onChange={(e) => handleSelectValues(e, 'mSelectBranch')}
                                                value={mSelectBranch}
                                                className="select-branch"
                                                menuPortalTarget={document.body}
                                                style={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Busqueda
                                            </Label>


                                            <Input
                                                type="search"
                                                placeholder="Buscar....."
                                                onChange={handleSearch}
                                                className="form-control"
                                                style={{
                                                    maxWidth: "400px",
                                                    borderRadius: "8px",
                                                    padding: "6px 10px",
                                                    fontSize: "14px",
                                                }}
                                            />
                                        </FormGroup>




                                        <br />
                                        <b>Acciones</b>
                                        <br /><br />
                                        <Button
                                            onClick={(e) => getReportPending(e, true)}
                                            disabled={loading}
                                            color="primary"
                                            block
                                            outline
                                            className="mb-3"
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            Buscar
                                        </Button>
                                        <Button
                                            onClick={handleClean}
                                            disabled={loading}
                                            color="danger"
                                            block
                                            outline
                                            className="mb-3"
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            Cancelar
                                        </Button>





                                        <Button
                                            color="success"
                                            onClick={exportExcel}
                                            block
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                transition: 'all 0.3s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            title="Descargar reporte"
                                        >
                                            <i className="pi pi-file-excel"></i>&ensp;
                                            Descargar
                                        </Button>

                                    </CardBody>


                                </Card>
                            </Col>

                            <Col sm="10">
                                <div style={{
                                    marginTop: '1px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    backgroundColor: '#fff'
                                }}>
                                    <DataTable
                                        value={reportPendingExams}
                                        rowExpansionTemplate={rowExpansionTemplate}
                                        expandedRows={expandedRows}
                                        onRowToggle={(e) => setExpandedRows(e.data)}
                                        paginator
                                        stripedRows
                                        rows={10}
                                        className="p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin resultados" />
                                                <br />
                                                <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                    Sin información de pendientes de laboratorio.
                                                </p>
                                            </div>
                                        }
                                        loading={loading}
                                        rowsPerPageOptions={[10, 50, 100]}
                                        responsiveLayout="scroll"


                                    >
                                        <Column style={{ width: '3em' }} headerStyle={headerStyle} body={(rowData) => (
                                            (rowData.type_exam === 'Perfil' || rowData.type_exam === 'Curva')
                                                ? (
                                                    <button
                                                        className="p-row-toggler"
                                                        aria-label="Toggle Row"
                                                        onClick={() => {
                                                            const isExpanded = expandedRows.some(r => r.nim === rowData.nim && r.exam_name === rowData.exam_name);
                                                            if (isExpanded) {
                                                                setExpandedRows(expandedRows.filter(r => !(r.nim === rowData.nim && r.exam_name === rowData.exam_name)));
                                                            } else {
                                                                setExpandedRows([...expandedRows, rowData]);
                                                            }
                                                        }}
                                                        style={{
                                                            border: 'none',
                                                            background: 'none',
                                                            cursor: 'pointer',
                                                            fontSize: '1.3em',
                                                            lineHeight: '1',
                                                            color: '#444'
                                                        }}
                                                    >
                                                        {expandedRows.some(r => r.nim === rowData.nim && r.exam_name === rowData.exam_name) ? '−' : '+'}
                                                    </button>
                                                ) : null
                                        )}
                                        />
                                        <Column field="nim" header="NIM" headerStyle={headerStyle} style={cellStyle} body={customBody} />
                                        <Column field="exam_name" header="Examen o Perfil" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="barcode" header="Etiqueta" headerStyle={{ backgroundColor: "#94bcd5", color: "#fff", fontWeight: "bold", fontSize: "12px" }} style={cellStyle} />
                                        <Column field="is_toma" header="Toma" sortable body={(rowData) => { if (rowData.type_exam === 'Perfil' || rowData.type_exam === 'Curva') return null; return renderStatus({ is_toma: rowData.is_toma, check_forwarded: rowData.check_forwarded }); }} headerStyle={{ backgroundColor: "#94bcd5", color: "#fff", fontWeight: "bold", fontSize: "12px" }} style={cellStyle} />
                                        <Column field="name_branch_origin" header="Sucursal Origen" headerStyle={{ backgroundColor: "#0079c7", color: "#fff", fontWeight: "bold", fontSize: "12px" }} style={cellStyle} />
                                        <Column field="is_send1" header="Envío" sortable body={(rowData) => { if (rowData.type_exam === 'Perfil' || rowData.type_exam === 'Curva') return null; return renderSend1Status(rowData); }} headerStyle={{ backgroundColor: "#0079c7", color: "#fff", fontWeight: "bold", fontSize: "12px" }} style={cellStyle} />
                                        <Column field="init_time_procces2" header="Fecha Envío" headerStyle={{ backgroundColor: "#0079c7", color: "#fff", fontWeight: "bold", fontSize: "12px" }} style={cellStyle} />
                                        <Column field="name_branch_destination" header="Sucursal Destino" headerStyle={{ backgroundColor: "#64bbe8", color: "#fff", fontWeight: "bold", fontSize: "12px" }} style={cellStyle} />
                                        <Column field="is_send2" header="Recepción" sortable body={(rowData) => { if (rowData.type_exam === 'Perfil' || rowData.type_exam === 'Curva') return null; return renderSend2Status(rowData); }} headerStyle={{ backgroundColor: "#64bbe8", color: "#fff", fontWeight: "bold", fontSize: "12px" }} style={cellStyle} />
                                        <Column field="init_time_procces3" header="Fecha Recepción" headerStyle={{ backgroundColor: "#64bbe8", color: "#fff", fontWeight: "bold", fontSize: "12px" }} style={cellStyle} />
                                    </DataTable>


                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Card>
            </div>

        </div>
    );
};
